/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { NativeStandardBackupSchedules } from '../models/NativeStandardBackupSchedules';

export class NativeStandardBackupPolicyPlan {
  /**
  * List of backup schedules. Each schedule specifies a backup frequency, retention period, and target region. 
  */
  'backupSchedules': Array<NativeStandardBackupSchedules>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "backupSchedules",
      "baseName": "backupSchedules",
      "type": "Array<NativeStandardBackupSchedules>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return NativeStandardBackupPolicyPlan.attributeTypeMap;
  }

  public constructor() {
  }
}

